export default {
    GET_ALL_ADS_LOADING: 'GET_ALL_ADS_LOADING',
    GET_ALL_ADS_SUCCESS: 'GET_ALL_ADS_SUCCESS',
    GET_ALL_ADS_FAILED: 'GET_ALL_ADS_FAILED',
    GET_ALL_ADS_REJECT: 'GET_ALL_ADS_REJECT',
  };